import ReactMarkdown from "react-markdown";
import rehypeSlug from "rehype-slug";
import rehypeRaw from "rehype-raw";


export default function MarkdownRenderer({children}) {
    return (
        <ReactMarkdown
            rehypePlugins={[rehypeSlug, rehypeRaw]}
            components={{
                a: ({node, ...props}) => (
                    <a {...props} target="_blank" rel="noopener noreferrer">
                        {props.children}
                    </a>
                )
            }}
        >
            {children}
        </ReactMarkdown>
    );
};
